import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    buttonTarget: {
        width: rem(32),
        height: rem(32),
        padding: 0,
        borderRadius: rem(58),
        border: "none",
    },

    iconTarget: {
        width: rem(16),
        height: rem(16),
        color: theme.colors.gray[7],
    },

    menuDropdown: {
        border: `${rem(1)} solid ${theme.colors.gray[2]}`,
        padding: rem(0),
    },

    searchInput: {
        margin: `${rem(8)} ${rem(12)}`,
        input: {
            backgroundColor: theme.colors.gray[1],
            border: "none",
            color: theme.colors.gray[6],
            "&:hover": {
                border: "none",
            },
        },
    },

    menuItem: {
        padding: rem(0),

        "&:hover": {
            backgroundColor: "transparent",
        },
    },

    accordionWrapper: {
        "&:hover": {
            backgroundColor: "transparent",
        },
    },

    accordionControl: {
        padding: `${rem(0)} ${rem(16)} ${rem(0)} ${rem(8)}`,
        "&:hover": {
            backgroundColor: "transparent",
        },
        "& .mantine-Accordion-chevron": {
            marginLeft: rem(0),
        },
    },

    accordionControlItem: {
        marginLeft: rem(12),
    },

    accordionControlText: {
        fontSize: rem(12),
        fontWeight: 500,
        color: theme.colors.gray[7],
    },

    accordionPanel: {
        "&:hover": {
            borderRadius: rem(4),
            backgroundColor: theme.colors.violet[1],
        },
    },

    accordionPanelFlex: {
        marginBottom: rem(-8),
    },

    placeholderLabel: {
        fontSize: rem(14),
        color: theme.colors.violet[9],
        marginLeft: rem(36),
        maxWidth: rem(180),
    },

    placeholderValue: {
        fontSize: rem(10),
        color: theme.colors.gray[9],
        fontFamily: "monospace, sans-serif",
        backgroundColor: theme.colors.gray[1],
        borderRadius: rem(4),
        padding: rem(4),
    },
}))
